export default __webpack_public_path__ + "static/media/visionofthesky.13ec06e3.png";